"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET = void 0;
const WIDGET = exports.WIDGET = 'widget';